const STATES = {
  LOADED: 'loaded',
  ERROR: 'error',
  LOADING: 'loading',
  ENDING: 'ending',
};

export { STATES };
